(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');
    module.factory('UserRole', ['RoleType', UserRoleFactoryFn]);

    /* factory for representing UserRole */
    function UserRoleFactoryFn(RoleType) {
        var UserRole = function (role) {
            // attributes
            this.name = role.name;
            this.value = role.value;

            //vm attributes
            this.vmNumber = 0; // badge number (fe filter bar)
            this.vmSelected = false; // selected state      
            this.vmIsReadonlyForCurrentUser = false; // readonly for logged in user

        };

        UserRole.prototype = {
            constructor: UserRole
        }; // prototype

        return UserRole;
    }
})();